import { Component, OnInit } from '@angular/core';
import {TooltipBaseComponent} from '../tooltip-base/tooltip-base.component';

@Component({
  selector: 'app-tooltip-email',
  templateUrl: './tooltip-email.component.html',
  styleUrls: ['./tooltip-email.component.scss']
})
export class TooltipEmailComponent extends TooltipBaseComponent implements OnInit {

  ngOnInit(): void {
  }

}
